<script setup lang="ts">
import { Button, PageHead } from '@itc/ui';
</script>

<template>
  <PageHead eyebrow="Error" title="Not allowed" sub="You don't have permission to open that page. Ask an admin if you think you should.">
    <template #actions><Button href="/">Go home</Button></template>
  </PageHead>
</template>
